module.exports = __webpack_public_path__ + "img/ina.3e461ff.jpg";